import { Sort } from "../catalog-utils";

export const getSortObject = (sortType: Sort) => {
    if (sortType === Sort.Popular) {
        return {
            created_at: {
                order: "asc"
            }
        };
    } else if (sortType === Sort.Cheap) {
        return {
            price: {
                order: "asc"
            }
        };
    } else if (sortType === Sort.Expensive) {
        return {
            price: {
                order: "desc"
            }
        };
    } else if (sortType === Sort.YearNewer) {
        return {
            year: {
                order: "desc"
            }
        };
    } else if (sortType === Sort.YearOlder) {
        return {
            year: {
                order: "asc"
            }
        };
    } else if (sortType === Sort.MileageLess) {
        return {
            mileage: {
                order: "asc",
                missing: "_first"
            }
        };
    } else if (sortType === Sort.MileageMore) {
        return {
            mileage: {
                order: "desc"
            }
        };
    } else if (sortType === Sort.ByName) {
        return {
            title: {
                order: "desc"
            }
        };
    } else {
        return {};
    }
};